const apiConfig={
	baseUrl: 'https://api.themoviedb.org/3/',
	apiKey: '9a193411abe2edd82171cfeaf1d75c8c',
	// originalImage: (imgPath)=> `https://image.tmdb.org/t/p/original/${imgPath}`,
	// w500Image: (imgPath)=> `https://image.tmdb.org/t/p/w500/${imgPath}`
}

export default apiConfig;